/* Cyber Vanguard 2026: reloj, estado antes/después de abrir y estado VIP.
   - La hora de apertura viene de snippets/cyber-state.liquid (atributo data-cyber-open, segundos UTC).
   - El reloj se calibra con la cabecera Date del servidor (no depende de la hora del computador).
   - La barra de anuncios (sections/cyber-bar.liquid) cuenta hasta el cierre que se define en el editor de esa sección.
   - QA: ?cyber_preview=pre | open fuerza el estado (solo en este navegador, sin efecto en la tienda). */
(function () {
  var root = document.documentElement;
  var OPEN_MS = parseInt(root.getAttribute('data-cyber-open'), 10) * 1000;
  if (!OPEN_MS) return;
  var offset = (parseInt(root.getAttribute('data-cyber-now'), 10) * 1000) - Date.now();
  var params = new URLSearchParams(location.search);
  var preview = params.get('cyber_preview');

  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function countdown(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), x = s % 60;
    return (d > 0 ? d + ' d ' : '') + pad(h) + ' h ' + pad(m) + ' min ' + pad(x) + ' s';
  }
  function elapsed(ms) {
    var m = Math.max(0, Math.floor(ms / 60000));
    var d = Math.floor(m / 1440), h = Math.floor((m % 1440) / 60), mm = m % 60;
    if (d > 0) return d + ' d ' + h + ' h';
    if (h > 0) return h + ' h ' + mm + ' min';
    return mm + ' min';
  }
  function set(sel, txt) {
    var list = document.querySelectorAll(sel);
    for (var i = 0; i < list.length; i++) if (list[i].textContent !== txt) list[i].textContent = txt;
  }
  /* Barra de anuncios: cuenta regresiva hasta el cierre (data-cyber-end en .cyber-bar, segundos UTC). */
  var barEl = document.querySelector('[data-cyber-end]');
  var END_MS = barEl ? parseInt(barEl.getAttribute('data-cyber-end'), 10) * 1000 : 0;
  function bar(now) {
    if (!END_MS) return;
    var s = Math.max(0, Math.floor((END_MS - now) / 1000));
    if (s === 0 && root.getAttribute('data-cyber-ended') !== '1') root.setAttribute('data-cyber-ended', '1');
    set('[data-cyber-cd="d"]', pad(Math.floor(s / 86400)));
    set('[data-cyber-cd="h"]', pad(Math.floor((s % 86400) / 3600)));
    set('[data-cyber-cd="m"]', pad(Math.floor((s % 3600) / 60)));
    set('[data-cyber-cd="s"]', pad(s % 60));
    /* Urgencia en la ficha de producto: "1d 07:43:04" (la píldora se muestra solo mientras falte tiempo) */
    var dd = Math.floor(s / 86400);
    set('[data-cyber-timer]', (dd > 0 ? dd + 'd ' : '') + pad(Math.floor((s % 86400) / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60));
    var pills = document.querySelectorAll('.cyber-timer');
    for (var q = 0; q < pills.length; q++) pills[q].classList.toggle('is-ready', s > 0);
  }
  function tick() {
    var now = Date.now() + offset;
    var state = 'open';
    var diff = now - OPEN_MS;
    if (preview === 'pre') { state = 'pre'; diff = -(2 * 86400 + 3 * 3600 + 12 * 60 + 5) * 1000; }
    if (preview === 'open') { state = 'open'; diff = (3 * 3600 + 12 * 60) * 1000; }
    if (root.getAttribute('data-cyber-state') !== state) root.setAttribute('data-cyber-state', state);
    set('[data-cyber-elapsed]', elapsed(diff));
    bar(now);
  }

  /* Estado VIP: se marca con ?vip=1 (enlace del correo) o al enviar el formulario de Klaviyo. Solo cambia mensajes. */
  function vip(on) {
    if (on) { try { localStorage.setItem('vg_vip', '1'); } catch (e) {} }
    var is = on; try { is = is || localStorage.getItem('vg_vip') === '1'; } catch (e) {}
    root.setAttribute('data-cyber-vip', is ? '1' : '0');
  }
  vip(params.get('vip') === '1');
  window.addEventListener('klaviyoForms', function (e) {
    var d = e && e.detail;
    if (d && d.type === 'submit') vip(true);
  });

  tick();
  setInterval(tick, 1000);

  /* Calibración con la hora del servidor (cabecera Date). Si falla, queda la hora que trajo la página. */
  try {
    fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' }).then(function (r) {
      var d = r.headers.get('Date');
      if (d) { offset = new Date(d).getTime() - Date.now(); tick(); }
    }).catch(function () {});
  } catch (e) {}

  /* Slider horizontal: flechas en escritorio (en móvil se desliza con el dedo) */
  var sliders = document.querySelectorAll('[data-cyber-slider]');
  for (var s = 0; s < sliders.length; s++) (function (wrap) {
    var track = wrap.querySelector('[data-cyber-track]');
    if (!track) return;
    function check() { wrap.classList.toggle('is-scrollable', track.scrollWidth - track.clientWidth > 4); }
    check(); window.addEventListener('resize', check);
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('[data-dir]'); if (!b) return;
      var card = track.querySelector('.cyber-catalog__card');
      var step = card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
      track.scrollBy({ left: parseInt(b.getAttribute('data-dir'), 10) * step, behavior: 'smooth' });
    });
  })(sliders[s]);

  /* Carrito: cambiar de nivel o agregar un complemento sin salir del cajón */
  function refreshDrawer(state) {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.renderContents === 'function' && state && state.sections) { d.renderContents(state); d.classList.remove('is-empty'); var inner = d.querySelector('.drawer__inner'); if (inner) inner.classList.remove('is-empty'); return; }
    window.location.reload();
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }
  /* Enlace de correo "Agregar al carrito": la ficha del producto recibe ?cyber_add=ID_VARIANTE, agrega ese sistema
     y abre el carrito lateral (sin ir a /cart). Se quita el parámetro de la URL para no repetirlo al recargar. */
  (function () {
    var vid = NaN;
    if (!vid || !/\/products\//.test(location.pathname)) return;
    try { params.delete('cyber_add'); var q = params.toString(); history.replaceState(null, '', location.pathname + (q ? '?' + q : '') + location.hash); } catch (e) {}
    var key = 'vg_cyber_add_' + vid;
    try { if (sessionStorage.getItem(key) === String(Math.floor(Date.now() / 60000))) return; sessionStorage.setItem(key, String(Math.floor(Date.now() / 60000))); } catch (e) {}
    function run() {
      post('/cart/add.js', { items: [{ id: vid, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
        .then(function (state) {
          if (state && state.status) return;
          customElements.whenDefined('cart-drawer').then(function () { setTimeout(function () { refreshDrawer(state); }, 150); });
        }).catch(function () {});
    }
    if (document.readyState === 'complete') run(); else window.addEventListener('load', run);
  })();

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cyber-add], [data-cyber-swap]');
    if (!b) return;
    e.preventDefault();
    var variant = parseInt(b.getAttribute('data-variant'), 10);
    var key = b.getAttribute('data-line-key');
    b.disabled = true;
    var go = key ? post('/cart/change.js', { id: key, quantity: 0 }) : Promise.resolve();
    go.then(function () {
      return post('/cart/add.js', { items: [{ id: variant, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname });
    }).then(refreshDrawer).catch(function () { window.location.reload(); });
  });

  /* "Agregar al carrito" de las tarjetas: agrega sin salir de la página y abre el cajón del carrito */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest ? e.target.closest('.cyber-catalog__form') : null;
    if (!f) return;
    e.preventDefault();
    var btn = f.querySelector('button'); var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Agregando…'; }
    var id = parseInt(f.querySelector('input[name="id"]').value, 10);
    post('/cart/add.js', { items: [{ id: id, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
      .then(function (state) {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        if (state && state.status) { window.location.href = '/cart'; return; }
        refreshDrawer(state);
      }).catch(function () { f.submit(); });
  }, true);

  /* El ícono del carrito siempre abre el cajón (nunca navega a /cart): si el JS del tema aún no está listo, espera a que lo esté */
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('#cart-icon-bubble') : null;
    if (!a) return;
    e.preventDefault();
    setTimeout(function () {
      var d = document.querySelector('cart-drawer');
      if (!d) { window.location.href = '/cart'; return; }
      if (d.classList.contains('active')) return;
      var done = false;
      var timer = setTimeout(function () { if (!done) window.location.href = '/cart'; }, 5000);
      customElements.whenDefined('cart-drawer').then(function () {
        done = true; clearTimeout(timer);
        if (!d.classList.contains('active') && typeof d.open === 'function') d.open(a);
      });
    }, 80);
  }, true);

  /* Franja del carrito: rota los mensajes (se vuelve a armar cada vez que el cajón se actualiza) */
  setInterval(function () {
    var boxes = document.querySelectorAll('[data-cyber-rotate]');
    for (var i = 0; i < boxes.length; i++) {
      var items = boxes[i].querySelectorAll('.cyber-msgs__item'); if (items.length < 2) continue;
      var on = -1; for (var k = 0; k < items.length; k++) if (items[k].classList.contains('is-on')) on = k;
      if (on >= 0) items[on].classList.remove('is-on');
      items[(on + 1) % items.length].classList.add('is-on');
    }
  }, 3500);

  /* Si el carrito bajó de tramo, se guardan en el pedido (atributo Regalos) los regalos que corresponden al monto */
  var cleaning = false;
  new MutationObserver(function () {
    if (cleaning) return;
    var box = document.querySelector('[data-cyber-gifts]'); if (!box) return;
    var sel = (box.getAttribute('data-selected') || ''), ok = box.querySelector('[data-cyber-valid]').getAttribute('data-cyber-valid');
    if (sel !== ok) { cleaning = true; post('/cart/update.js', { attributes: { Regalos: ok } }).then(function () { cleaning = false; box.setAttribute('data-selected', ok); }).catch(function () { cleaning = false; }); }
  }).observe(document.body, { childList: true, subtree: true });

  /* Aviso al desbloquear un regalo nuevo al agregar productos */
  var lastUnlocked = null;
  new MutationObserver(function () {
    var s = document.querySelector('[data-cyber-unlocked]'); if (!s) return;
    var n = parseInt(s.getAttribute('data-cyber-unlocked'), 10) || 0;
    if (lastUnlocked !== null && n > lastUnlocked && !s.querySelector('.cyber-reward__unlock')) {
      var gifts = document.querySelectorAll('.cyber-gift:not(.cyber-meet)');
      for (var i = lastUnlocked; i < n && i < gifts.length; i++) gifts[i].classList.add('is-new');
      var m = document.createElement('p'); m.className = 'cyber-reward__unlock';
      m.innerHTML = '&#127881; <b>¡Desbloqueaste ' + (n - lastUnlocked === 1 ? 'un regalo nuevo' : (n - lastUnlocked) + ' regalos nuevos') + '!</b> Ya está incluido abajo, sin costo.';
      s.insertBefore(m, s.firstChild);
    }
    lastUnlocked = n;
  }).observe(document.body, { childList: true, subtree: true });

  /* Montos al estilo chileno: $54,990 -> $54.990 en todo el tema (el formato de la tienda usa coma) */
  var RX = /\$\s?\d{1,3}(?:,\d{3})+/g;
  function fixText(root) {
    if (!root) return;
    var w = document.createTreeWalker(root.nodeType === 3 ? root.parentNode : root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode && n.parentNode.nodeName;
        if (p === 'SCRIPT' || p === 'STYLE' || p === 'TEXTAREA' || p === 'NOSCRIPT') return NodeFilter.FILTER_REJECT;
        return n.nodeValue.indexOf(',') > -1 && n.nodeValue.indexOf('$') > -1 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var n, list = [];
    while ((n = w.nextNode())) list.push(n);
    list.forEach(function (t) { t.nodeValue = t.nodeValue.replace(RX, function (m) { return m.replace(/,/g, '.'); }); });
  }
  fixText(document.body);
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (a) { if (a.nodeType === 1 || a.nodeType === 3) fixText(a); });
      if (m.type === 'characterData') fixText(m.target);
    });
  }).observe(document.body, { childList: true, subtree: true, characterData: true });

  /* Riel de ofertas del carrito: puntos que indican cuál tarjeta se ve */
  function railDots() {
    document.querySelectorAll('[data-cyber-rail]').forEach(function (r) {
      var d = r.parentNode.querySelector('[data-cyber-dots]'); if (!d) return;
      var cards = r.children;
      if (cards.length < 2) { d.style.display = 'none'; return; }
      if (d.children.length !== cards.length) { d.innerHTML = ''; for (var i = 0; i < cards.length; i++) d.appendChild(document.createElement('i')); }
      var idx = Math.round(r.scrollLeft / (cards[0].offsetWidth + 8));
      for (var k = 0; k < d.children.length; k++) d.children[k].classList.toggle('is-on', k === idx);
      if (!r.__cyberRail) { r.__cyberRail = true; r.addEventListener('scroll', railDots, { passive: true }); }
    });
  }
  new MutationObserver(railDots).observe(document.body, { childList: true, subtree: true });
  railDots();

  /* Opiniones reales del primer producto del carrito (las carga la app de reseñas) */
  function fillReviews() {
    var el = document.querySelector('[data-cyber-reviews]'); if (!el) return;
    var c = document.querySelector('cart-drawer .cart-drawer-item .dd-review-count'); if (!c) return;
    var n = (c.textContent.match(/\d+/) || [])[0]; if (!n || +n < 1) { el.hidden = true; return; }
    var t = '\u2605 ' + n + ' opiniones de clientes en este sistema';
    if (el.textContent !== t) { el.textContent = t; el.hidden = false; }
  }
  new MutationObserver(fillReviews).observe(document.body, { childList: true, subtree: true });
  fillReviews();

  /* Productos sin opiniones: se oculta el "(0)" y las estrellas grises (no se muestra nada que no exista) */
  function hideEmptyStars() {
    document.querySelectorAll('.ddreview-star .dd-review-count').forEach(function (c) {
      if (/^\(\s*0\s*\)$/.test(c.textContent.trim())) { var s = c.closest('.ddreview-star'); if (s) s.classList.add('cyber-no-reviews'); }
    });
  }
  new MutationObserver(hideEmptyStars).observe(document.body, { childList: true, subtree: true });
  hideEmptyStars();

  /* "Por qué nos necesitas": al aparecer en pantalla el gráfico se dibuja solo (no bloquea el scroll) */
  (function () {
    var sec = document.querySelector('[data-cyber-why]'); if (!sec) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    var line = sec.querySelector('[data-why-line]'), head = sec.querySelector('[data-why-head]'), clip = sec.querySelector('[data-why-clip]');
    var pts = sec.querySelector('[data-why-points]'), cards = sec.querySelectorAll('.cyber-why__card'), count = sec.querySelector('[data-why-count]');
    var L = line.getTotalLength(), n = cards.length - 1, NS = 'http://www.w3.org/2000/svg', marks = [];
    for (var i = 0; i < n; i++) {
      var t = (i + 1) / (n + 1) * 0.92 + 0.04; marks.push(t);
      var p = line.getPointAtLength(L * t), c = document.createElementNS(NS, 'circle');
      c.setAttribute('cx', p.x); c.setAttribute('cy', p.y); c.setAttribute('r', 6); c.setAttribute('class', 'cyber-why__pt'); pts.appendChild(c);
    }
    var circles = pts.querySelectorAll('circle'), target = parseInt(count.getAttribute('data-to'), 10) || 450;
    function draw(f) {
      line.style.strokeDashoffset = L * (1 - f);
      var pt = line.getPointAtLength(L * f);
      head.setAttribute('cx', pt.x); head.setAttribute('cy', pt.y); clip.setAttribute('width', pt.x);
      for (var k = 0; k < n; k++) { var on = f >= marks[k]; circles[k].classList.toggle('is-on', on); cards[k].classList.toggle('is-on', on); }
      var done = f >= 1; cards[n].classList.toggle('is-on', done);
    }
    line.style.strokeDasharray = L; sec.classList.add('is-live'); draw(0); count.textContent = '0';
    var played = false;
    new IntersectionObserver(function (es, io) {
      if (!es[0].isIntersecting || played) return;
      played = true; io.disconnect();
      var start = null, dur = 2800;
      (function step(ts) {
        if (start === null) start = ts;
        var x = Math.min((ts - start) / dur, 1), f = 1 - Math.pow(1 - x, 2.2);
        draw(f);
        var cp = Math.max(0, (x - 0.7) / 0.3); count.textContent = Math.round(target * Math.min(cp, 1));
        if (x < 1) requestAnimationFrame(step); else { draw(1); count.textContent = target; }
      })(performance.now());
    }, { threshold: 0.45 }).observe(sec);
  })();

  /* Fondo con profundidad: los círculos de luz se desplazan distinto al scroll (solo mueve transform, no frena la página) */
  (function () {
    var sec = document.querySelector('[data-cyber-why]'); if (!sec || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var tick = false;
    function upd() { tick = false; var r = sec.getBoundingClientRect(); if (r.bottom < 0 || r.top > window.innerHeight) return; sec.style.setProperty('--cw-y', ((r.top + r.height / 2 - window.innerHeight / 2) * 0.18).toFixed(1) + 'px'); }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true }); upd();
  })();

  /* Página de sistemas: el selector baja suave hasta el grupo y marca el que se está viendo (sin cambiar de página) */
  (function () {
    var root = document.querySelector('[data-cyber-sys]'); if (!root) return;
    var tabs = root.querySelectorAll('[data-sys-tab]'), groups = root.querySelectorAll('[data-sys-group]'), bar = root.querySelector('.cyber-sys__tabs');
    function stickTop() { var h = document.querySelector('header.header, .header-wrapper, .section-header header'); var b = h ? h.getBoundingClientRect().bottom : 0; root.style.setProperty('--cs-top', Math.max(0, Math.round(b)) + 'px'); }
    function setOn(id) { tabs.forEach(function (t) { t.classList.toggle('is-on', t.getAttribute('data-sys-tab') === id); }); }
    tabs.forEach(function (t) {
      t.addEventListener('click', function (e) {
        var g = document.getElementById(t.getAttribute('data-sys-tab')); if (!g) return;
        e.preventDefault(); setOn(t.getAttribute('data-sys-tab'));
        var y = g.getBoundingClientRect().top + window.scrollY - (bar.offsetHeight + (parseInt(getComputedStyle(root).getPropertyValue('--cs-top'), 10) || 0)) + 2;
        window.scrollTo({ top: y, behavior: 'smooth' });
        if (history.replaceState) history.replaceState(null, '', '#' + t.getAttribute('data-sys-tab'));
      });
    });
    var tick = false;
    function spy() {
      tick = false; stickTop();
      var line = bar.getBoundingClientRect().bottom + 40, cur = groups[0].id;
      groups.forEach(function (g) { if (g.getBoundingClientRect().top <= line) cur = g.id; });
      setOn(cur);
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(spy); } }, { passive: true });
    window.addEventListener('resize', spy); spy();
    if (location.hash) { var g0 = document.getElementById(location.hash.slice(1)); if (g0 && g0.hasAttribute('data-sys-group')) setTimeout(function () { var t = root.querySelector('[data-sys-tab="' + g0.id + '"]'); t && t.click(); }, 300); }
  })();

  /* Tu portal: el portal de muestra cambia de sección solo y también al tocar (no frena el scroll) */
  (function () {
    var demo = document.querySelector('[data-portal-demo]'); if (!demo) return;
    var tabs = demo.querySelectorAll('[data-pd-tab]'), panels = demo.querySelectorAll('[data-pd-panel]'), idx = 0, timer = null;
    function show(i) { idx = i; tabs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); }); panels.forEach(function (p, k) { p.classList.toggle('is-on', k === i); }); }
    function play() { if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; stop(); timer = setInterval(function () { show((idx + 1) % tabs.length); }, 3200); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    tabs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); stop(); setTimeout(play, 9000); }); });
    new IntersectionObserver(function (es) { es[0].isIntersecting ? play() : stop(); }, { threshold: 0.3 }).observe(demo);
  })();

  /* Línea de tiempo del portal: se llena al aparecer en pantalla */
  (function () {
    var f = document.querySelector('.cyber-tp__flow'); if (!f) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) { f.classList.add('is-in'); return; }
    new IntersectionObserver(function (es, io) { if (es[0].isIntersecting) { f.classList.add('is-in'); io.disconnect(); } }, { threshold: 0.35 }).observe(f);
  })();

  /* Dudas: los atajos bajan suave al grupo y marcan el que se está viendo */
  (function () {
    var tabs = document.querySelectorAll('[data-dd-tab]'); if (!tabs.length) return;
    tabs.forEach(function (t) { t.addEventListener('click', function (e) { var g = document.getElementById(t.getAttribute('data-dd-tab')); if (!g) return; e.preventDefault(); window.scrollTo({ top: g.getBoundingClientRect().top + window.scrollY - 130, behavior: 'smooth' }); }); });
    var groups = [].map.call(tabs, function (t) { return document.getElementById(t.getAttribute('data-dd-tab')); }), tick = false;
    function spy() { tick = false; var cur = 0; groups.forEach(function (g, i) { if (g.getBoundingClientRect().top <= 200) cur = i; }); tabs.forEach(function (t, i) { t.classList.toggle('is-on', i === cur); }); }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(spy); } }, { passive: true }); spy();
  })();

  /* Dudas: cifras que suben al aparecer y lista que enfoca una ventaja a la vez (se mueve sola y también al tocar) */
  (function () {
    var nums = document.querySelector('[data-nums]'), ft = document.querySelector('[data-ft]'); if (!nums || !ft) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var els = nums.querySelectorAll('[data-count-to]');
    if (!reduce && 'IntersectionObserver' in window) {
      els.forEach(function (e) { e.textContent = '0'; });
      new IntersectionObserver(function (es, io) {
        if (!es[0].isIntersecting) return; io.disconnect();
        var t0 = null; (function step(ts) { if (t0 === null) t0 = ts; var x = Math.min((ts - t0) / 1600, 1), k = 1 - Math.pow(1 - x, 3);
          els.forEach(function (e) { e.textContent = Math.round(parseInt(e.getAttribute('data-count-to'), 10) * k); }); if (x < 1) requestAnimationFrame(step); })(performance.now());
      }, { threshold: 0.5 }).observe(nums);
    }
    if (reduce) return;
    var rows = ft.querySelectorAll('[data-ft-row]'), idx = 0, timer = null, DUR = 2200;
    ft.style.setProperty('--ft-dur', DUR + 'ms'); ft.classList.add('is-live');
    function show(i) { idx = i; rows.forEach(function (r, k) { r.classList.remove('is-on'); r.querySelector('.cyber-ft__head').setAttribute('aria-expanded', 'false'); }); void ft.offsetWidth; rows[i].classList.add('is-on'); rows[i].querySelector('.cyber-ft__head').setAttribute('aria-expanded', 'true'); var ds = document.querySelectorAll('[data-ft-desc] p'); ds.forEach(function (p, k) { p.classList.toggle('is-on', k === i); }); }
    function play() { stop(); timer = setInterval(function () { show((idx + 1) % rows.length); }, DUR); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    rows.forEach(function (r, k) { r.querySelector('.cyber-ft__head').addEventListener('click', function () { show(k); play(); }); });
    new IntersectionObserver(function (es) { es[0].isIntersecting ? (show(idx), play()) : stop(); }, { threshold: 0.4 }).observe(ft);
  })();

  /* Ficha de producto: el tipo de sistema va siempre en una sola línea (reduce la letra si hace falta) */
  (function () {
    function fit() { document.querySelectorAll('[data-fit-line]').forEach(function (el) { el.style.removeProperty('font-size'); var fs = parseFloat(getComputedStyle(el).fontSize); while (el.scrollWidth > el.clientWidth + 1 && fs > 9) { fs -= 0.5; el.style.setProperty('font-size', fs + 'px', 'important'); } }); }
    fit(); window.addEventListener('resize', fit); if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  })();

  /* "Comprar ahora": agrega el producto y va directo al pago */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-buy-now]'); if (!b || b.disabled) return;
    e.preventDefault();
    var form = b.closest('.v-product-hero__cta'), inp = form && form.querySelector('input.product-variant-id');
    var id = parseInt((inp && inp.value) || b.getAttribute('data-variant'), 10);
    b.disabled = true;
    post('/cart/add.js', { items: [{ id: id, quantity: 1 }] }).then(function () { window.location.href = '/checkout'; }).catch(function () { b.disabled = false; });
  });

  /* Reseñas de la ficha: tarjeta de resumen y encabezado con avatar en cada reseña */
  (function () {
    var sec = document.querySelector('.trustpilot-reviews'); if (!sec) return;
    function build() {
      if (sec.getAttribute('data-vg-rv')) return;
      var h1 = document.querySelector('h1.v-product-hero__title, .v-product-hero__title'), name = h1 ? h1.textContent.trim() : '';
      var img = document.querySelector('.v-product-hero__stage img[src], .v-product-hero img[src]');
      var cnt = document.querySelector('.v-product-hero .dd-review-count') || document.querySelector('.dd-review-count'), n = cnt ? (cnt.textContent.match(/\d+/) || [])[0] : null;
      var head = sec.querySelector('.trustpilot-reviews__content-container');
      sec.querySelectorAll('.trustpilot-review').forEach(function (c) {
        if (c.querySelector('.vg-rv-head')) return;
        var a = c.querySelector('.testimonial-card__author'); if (!a) return;
        var st = a.querySelector('strong'), nm = st ? st.textContent.trim() : a.textContent.trim().split('\u2014')[0].trim();
        var sub = a.textContent.replace(nm, '').replace(/^\s*[\u2014\-]\s*/, '').trim();
        var ini = nm.split(/\s+/).slice(0, 2).map(function (w) { return w.charAt(0); }).join('').toUpperCase();
        var hd = document.createElement('div'); hd.className = 'vg-rv-head';
        hd.innerHTML = (img ? '<img class="vg-rv-av vg-rv-av--img" alt="" src="' + (img.currentSrc || img.getAttribute('src') || '') + '">' : '<span class="vg-rv-av"></span>') + '<div><b></b><small></small></div>';
        if (!img) hd.querySelector('.vg-rv-av').textContent = ini; hd.querySelector('b').textContent = nm; hd.querySelector('small').textContent = sub;
        c.insertBefore(hd, c.firstChild); var stars = document.createElement('div'); stars.className = 'vg-rv-stars'; stars.setAttribute('aria-hidden', 'true'); stars.textContent = '\u2605\u2605\u2605\u2605\u2605'; hd.after(stars);
      });
      sec.setAttribute('data-vg-rv', '1');
    }
    build(); setTimeout(build, 1200); window.addEventListener('load', build); setTimeout(function () { var s = sec.querySelector('.vg-rv-sum'), c = document.querySelector('.dd-review-count'); if (s && c && !s.querySelector('.vg-rv-sum__stars')) { var n = (c.textContent.match(/\\d+/) || [])[0]; if (n && n !== '0') { var w = document.createElement('div'); w.className = 'vg-rv-sum__stars'; w.innerHTML = '<i aria-hidden="true">\u2605\u2605\u2605\u2605\u2605</i><span>' + n + ' rese\u00f1as</span>'; s.querySelector('b').after(w); } } }, 3500);
  })();

  /* Por qué Vanguard: la cifra sube al aparecer y el caso elegido cambia la respuesta (también solo, cada 4 s) */
  (function () {
    var sec = document.querySelector('[data-vg]'); if (!sec) return;
    var tabs = sec.querySelectorAll('[data-vg-tab]'), ans = sec.querySelectorAll('[data-vg-ans]'), cnt = sec.querySelector('[data-vg-count]'), idx = 0, timer = null;
    function show(i) { idx = i; tabs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); }); ans.forEach(function (a, k) { a.classList.toggle('is-on', k === i); }); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function play() { stop(); if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; timer = setInterval(function () { show((idx + 1) % tabs.length); }, 4200); }
    tabs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); play(); }); });
    if (!('IntersectionObserver' in window)) return;
    var counted = false, to = parseInt(cnt.getAttribute('data-to'), 10) || 450;
    new IntersectionObserver(function (es) {
      var on = es[0].isIntersecting; on ? play() : stop();
      if (on && !counted && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        counted = true; var t0 = null; cnt.textContent = '0';
        (function step(ts) { if (t0 === null) t0 = ts; var x = Math.min((ts - t0) / 1500, 1); cnt.textContent = Math.round(to * (1 - Math.pow(1 - x, 3))); if (x < 1) requestAnimationFrame(step); })(performance.now());
      }
    }, { threshold: 0.4 }).observe(sec);
  })();

  /* Etiqueta Cyber sobre la imagen principal de la ficha, con el descuento real del producto */
  (function () {
    var stage = null; if (!stage) return;
    var d = document.querySelector('.v-product-hero__price .v-price__discount');
    var b = document.createElement('span'); b.className = 'vg-cyber-badge'; b.textContent = 'Cyber' + (d ? ' ' + d.textContent.trim() : '');
    stage.appendChild(b);
  })();
})();
